<template>
    <div @click="$emit('click')" :class="{ 'bg-near-white' : isSelected }" class="no-underline flex pa3 bb b--light-gray hover-bg-near-white items-center pointer">
        <img style="width:45px; height:45px;" :src="require('@/assets/img/avatars/' + thread.avatar)">
        <div class="w-100 ph3">
            <div class="flex justify-between items-center mv1">
                <div class="flex items-center">
                    <h6 :class="{'yellow' : thread.unread != 0, 'black' : thread.unread == 0}">{{thread.display_name}}</h6>
                    <span v-if="thread.unread != 0" class="bg-yellow dot ml2"/>
                </div>
                <div class="legal black">{{thread.created_at | moment("MMM DD [at] h:mma")}}</div>
            </div>
            <div class="legal mid-gray">{{messageText}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isSelected: {
            type: Boolean,
            default: false
        },
        thread: {
            type: Object,
            required: true
        }
    },
    computed: {
        messageText() {
            return this.thread.type == 'OutboundText'
                ? 'You: ' + this.thread.text
                : this.thread.text;
        }
    }
};
</script>

<style scoped>
.dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
}
</style>
